/**
 * 报文主体
 */
export default class SQLBuilderItem {
  constructor () {
    this.SQLBuilderID = ''  //BAPI脚本MID
    this.TableName = ''     //表名
    this.Caption = ''       //标题
    this.Enabled = true     //默认启用
    this.Save = []          //保存
    this.Execute = []       //执行 by modify
    this.Select = {}        //查询
  }
}


// WEBPACK FOOTER //
// ./src/wbap-core-commit/model/SQLBuilderItem.js